<template lang="pug">
  .page.page_videoinstruction
    header.page__header
      h2.page__title
        transition(name="transition-title" appear)
          span {{ $t('videoinstruction.title') }}
      span.page__close
        transition(name="transition-title" appear)
          span(@click="$router.push({path: '/'})") {{ $t('videoinstruction.close') }}
    div(class="page__player")
      | <iframe class="page__instruction-frame" src="https://www.youtube.com/embed/nnu_ptgirho" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'VideoInstruction',
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    })
  },
  created () {
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    document.body.removeAttribute('style')
  }
}
</script>

<style scoped>
    .transition-enter-active {
        transition: all .3s ease-out;
        transition-delay: .4s;
    }
    .transition-leave-active {
        transition: all .3s ease-out;
        transition-delay: 1s;
    }
    .transition-enter, .transition-title-enter {
        transform: translateY(100%);
    }
    .transition-leave-to, .transition-title-leave-to {
        transform: translateY(100%);
    }

    .transition-title-enter-active {
        transition: all .3s ease-out;
        transition-delay: .3s;
    }

</style>



// WEBPACK FOOTER //
// src/components/VideoInstruction.vue